import React from 'react'
import { animateScroll as scroll } from 'react-scroll'
import {FaBars, FaDiscord, FaTwitter} from 'react-icons/fa'
import { RiFilePaper2Line } from 'react-icons/ri'
import openSeaLogo from '../../images/OpenSeaWhite.svg'
import whitePaper from '../../whitepaper.pdf'

import {
  Nav, 
  NavbarContainer, 
  NavLogo, 
  MobileIcon, 
  NavMenu,
  NavItem, 
  NavLinks, 
  NavSocials, 
  SocialItem,
  NavRoute } from './NavbarElements'
import {DISCORD_URL} from "../../App";



const Navbar = ({toggleMenu}) => {
  
  const toggleHome = () => {
    scroll.scrollToTop()
  }

  const betaRelease = () => {
    if(true){
      return <NavItem>
              <NavRoute to="brainzshop">$Brainz Shop</NavRoute>
            </NavItem>
    }
    return
  }

    return (
        <>
          <Nav classname="nav">
            <NavbarContainer>
              <NavLogo to='/' onClick={toggleHome}>Bit Monsters</NavLogo>
              <MobileIcon onClick={toggleMenu}>
                <FaBars />
              </MobileIcon>
              <NavMenu>
                <NavItem>
                  <NavLinks 
                    to="mint"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact='true'
                  >Mint</NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks 
                    to="about"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact='true'
                  >About</NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks to="brainz"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact='true'
                  >$BRAINZ</NavLinks>
                </NavItem>
                { betaRelease() }
              </NavMenu>
              <NavSocials>
                <SocialItem to={{ pathname: DISCORD_URL }} target="_blank"><FaDiscord size={30}/></SocialItem>
                <SocialItem to={{ pathname: "https://twitter.com/bit_monsters" }} target="_blank"><FaTwitter size={30}/></SocialItem>
                <SocialItem to={{ pathname: "https://opensea.io/collection/bit-monsters-nft" }} target="_blank"><img src={openSeaLogo} alt="Open Sea Logo"/></SocialItem>
                <SocialItem to={whitePaper} target="_blank"><RiFilePaper2Line size={30}/></SocialItem>
              </NavSocials>
            </NavbarContainer>  
          </Nav>      
        </>
    )
}

export default Navbar
